<template>
  <div>
    <header id="blog-header">
      <div class="inner ">
        <h1 class="blog-name">
          <router-link :to="{ name: 'tagContent', params: { tag: tag }}">{{ tag }}</router-link>
        </h1>
        <search-bar
          v-model="searchKeyword"
          :placeholder="`在 ${tag} 标签中搜索`"
          :suggestions="suggestions"
          @search="handleSearch"
        ></search-bar>
      </div>
    </header>

    <all-blogposts :func="func" :key="refresh" :search-query="searchKeyword"></all-blogposts>
  </div>

</template>

<script>
import allBlogposts from './AllBlogPosts'
import SearchBar from '../components/SearchBar'
import { fetchSearchSuggestions, normalizeKeyword } from '../utils/search'
export default {
  name: 'tag-content',
  components: {
    allBlogposts,
    SearchBar
  },
  data () {
    return {
      func: 'tag',
      tag: '',
      refresh: true,
      searchKeyword: this.$route.query.q || '',
      suggestions: []
    }
  },
  created () {
    if (this.$route.params.tag) {
      let tag = this.$route.params.tag
      this.tag = tag
      console.log(tag)
      this.loadSuggestions(tag)
    }
  },
  watch: {
    '$route' (to, from) {
      if (this.$route.params.tag) {
        let tag = this.$route.params.tag
        this.tag = tag
        console.log('tag in tagContent:' + tag)
        this.refresh = !this.refresh
        this.loadSuggestions(tag)
      }
      if (this.$route.query.q !== undefined || this.searchKeyword) {
        this.searchKeyword = this.$route.query.q || ''
      }
    }
  },
  methods: {
    async loadSuggestions (tag) {
      this.suggestions = await fetchSearchSuggestions(this.$http, this.$store.state.baseUrl, { tag })
    },
    handleSearch (keyword) {
      const trimmed = normalizeKeyword(keyword)
      this.searchKeyword = trimmed
      const routeTarget = {
        name: 'tagContent',
        params: { tag: this.tag },
        query: trimmed ? { q: trimmed } : {}
      }
      if (this.$route.params.topage) {
        routeTarget.params.topage = 1
      }
      this.$router.push(routeTarget)
    }
  }
}
</script>

<style scoped>
</style>
